import type { PhoneCallTone } from "@phone/phoneCallOutcome";
import { StatusMark, Swipe } from "@scribenote/brian-design-system";

export const OutcomeChip = ({
  label,
  tone,
}: {
  label: string;
  tone: PhoneCallTone;
}) =>
  tone === "neutral" ? (
    <StatusMark>{label}</StatusMark>
  ) : (
    <Swipe tone={tone} className="text-annotation-caps">
      {label}
    </Swipe>
  );
